import React, { useEffect } from "react";
import "../App-development/app-development.scss";
import AOS from "aos";
import "aos/dist/aos.css";
import LazyLoader from "../Common-features/LazyLoader";
import { useNavigate } from 'react-router-dom';
const ServiceBanner = ({ data }) => {
  useEffect(() => {
    AOS.init({
      once: false,
    });
  }, []);
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/request-a-demo', { state: { ttl2: "Let's connect", dec: "Let's bridge the gap and bring ideas to reality: Connect with us now!" } });
  };
  return (
    <section className="banner-app-devl">
      <div className="banner-caption-sec">
        <div className="container">
          <div className="caption-banner">
            <div className="ban-caption">
              <h1
                className="big-ttl"
                id="heading"
                dangerouslySetInnerHTML={{ __html: data[0].title }}
              ></h1>

              <button className='btn' onClick={handleClick}>
                <span>{data[0].bannerBtnText}</span>
              </button>
            </div>
            <div className="banr-img">
              <LazyLoader
                src={data[0].bannerBigimg}
                alt={data[0].bannerAlt}
                className="img-fluid banner-big-img"
                width="517"
                height="481"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceBanner;
